jQuery(document).ready(function($) {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 40) {
            jQuery('.site-header__logo-link').addClass('small-logo');
            jQuery('.logo-icon').css("display","none");
            jQuery('.logo-desk').css("display","block");
            jQuery('.logo-mob').css("display","block");
        } else {
            jQuery('.site-header__logo-link').removeClass('small-logo');
            jQuery('.logo-icon').css("display","block");
            jQuery('.logo-desk').css("display","none");
            jQuery('.logo-mob').css("display","none");
        }
    });
});